import React from "react";

/**
 * Ranked refresh candidates from a run summary.
 *
 * The `reasons` array is the whole point of a dry run — it explains WHY the
 * scorer picked a post — so it gets its own full-width row rather than being
 * squeezed into a cell and truncated.
 */
const RefreshCandidatesTable = ({ candidates }) => {
  const rows = candidates || [];

  if (!rows.length) {
    return (
      <p className="text-sm text-gray-500 px-5 py-4">
        No posts met the refresh thresholds — nothing is decaying enough to be worth rewriting.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-gray-500 border-b border-gray-200">
            <th className="px-5 py-2 font-medium">Post</th>
            <th className="px-5 py-2 font-medium text-right">Score</th>
            <th className="px-5 py-2 font-medium text-right">Position</th>
            <th className="px-5 py-2 font-medium text-right">Impressions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {rows.map((c, i) => (
            <React.Fragment key={c.slug || i}>
              <tr className={i === 0 ? "bg-indigo-50/40" : ""}>
                <td className="px-5 pt-3 pb-1 font-medium text-gray-900">
                  {i === 0 && (
                    <span className="inline-block mr-2 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide bg-indigo-600 text-white rounded">
                      Top pick
                    </span>
                  )}
                  {c.title}
                  <span className="block text-xs text-gray-500 font-normal mt-0.5">/{c.slug}</span>
                </td>
                <td className="px-5 pt-3 pb-1 text-right tabular-nums font-semibold text-gray-900">
                  {c.score}
                </td>
                <td className="px-5 pt-3 pb-1 text-right tabular-nums text-gray-600">
                  {c.position ?? "—"}
                </td>
                <td className="px-5 pt-3 pb-1 text-right tabular-nums text-gray-600">
                  {c.impressions ?? "—"}
                </td>
              </tr>
              <tr className={i === 0 ? "bg-indigo-50/40" : ""}>
                <td colSpan={4} className="px-5 pt-0 pb-3">
                  <ul className="text-xs text-gray-600 space-y-0.5">
                    {(c.reasons || []).map((r, j) => (
                      <li key={j} className="flex gap-1.5">
                        <span className="text-gray-400 shrink-0">•</span>
                        <span>{r}</span>
                      </li>
                    ))}
                  </ul>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RefreshCandidatesTable;
